(function () {
'use strict';

angular
    .module('directives.textareaRead', [])
    .directive('textareaRead', directive);
        
directive.$inject = [];

function directive() {
    return {
        restrict: 'AE',
        scope: {
            model: '=',
            preClasses: '='
        },
        templateUrl: require('./textareaRead.tpl.html'),
        controller: ['$scope', function ($scope) {

            // Has Been Edited with Text Angular
            $scope.hasBeenEditedWithTextAngular = function (model) {
                var rgx = /<p>/i;

                return rgx.test(model);
            };
        }]
    };
}
})();